module.exports = "<nv-react-component component=\"Bs4Testbed\"></nv-react-component>";